'use client';

export default function Error({ reset }) {
  return (
    <div className="error-container">
      <h2 className="error-title">Something went wrong</h2>
      <p className="error-message">We apologize for the inconvenience. Please try again.</p>
      <button className="btn-primary" onClick={() => reset()}>
        Try Again
      </button>
    </div>
  );
}
